import { useState, useEffect, useRef } from 'react'
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Fab,
  Tooltip,
  IconButton,
  Autocomplete
} from '@mui/material'

import { useForm, Controller } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
import { useNavigate, useParams } from 'react-router-dom'
import Icon from '../../../../components/icon';

import apiUrl from '../../../../configs/constant'
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto'
import MsiDatagridAutoPlain from '../../../../components/custom/MsiDatagridAutoPlain'
import DialogBiayaLainnya from '../../../../components/acc/accarr/DialogBiayaLainnya'
import { useToast } from '../../../../components/ToastProvider'
import FloatingJurnalButton from '../../../../components/acc/jurnal/FabJurnal'

interface FormInputs {
  vendor_id: any
  vendor_name: any
  tgl: any
  keterangan: any
  is_langsung: number
  nomor_penerimaan: any
  accakun_id: any
  sisa_saldo: any
  total: any
  total_cair: any
  total_valas: any

  accinv_id: any
  sisa: any
  keterangan_invoice: any
  total_invoice: any

  akun: any
  total_biaya: any
  keterangan_biaya: any
}

const formatNumber = (value: string) => {
  const raw = value.replace(/[^0-9,]/g, '')
  const parts = raw.split(',')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return parts.join(',')
}

const terbilang = (nominal: number) => {
  if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

  const satuan = ['', 'SATU', 'DUA', 'TIGA', 'EMPAT', 'LIMA', 'ENAM', 'TUJUH', 'DELAPAN', 'SEMBILAN', 'SEPULUH', 'SEBELAS']

  const penyebut = (n: number): string => {
    if (n < 12) return satuan[n]
    if (n < 20) return `${penyebut(n - 10)} BELAS`
    if (n < 100) return `${penyebut(Math.floor(n / 10))} PULUH ${penyebut(n % 10)}`
    if (n < 200) return `SERATUS ${penyebut(n - 100)}`
    if (n < 1000) return `${penyebut(Math.floor(n / 100))} RATUS ${penyebut(n % 100)}`
    if (n < 2000) return `SERIBU ${penyebut(n - 1000)}`
    if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} RIBU ${penyebut(n % 1000)}`
    if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} JUTA ${penyebut(n % 1000000)}`
    if (n < 1000000009) return `${penyebut(Math.floor(n / 1e9))} MILIAR ${penyebut(n % 1e9)}`
    return 'Angka terlalu besar'
  }

  const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

  return `${result} RUPIAH`
}

const AccAppDetail = () => {
  const userData = JSON.parse(localStorage.getItem('user')!)
  const token = userData.token
  const navigate = useNavigate()
  const { id } = useParams()
  const { showToast, hideToast } = useToast();

  const inputRef = useRef<HTMLInputElement>(null)

  const [openVendor, setOpenVendor] = useState(false)
  const [openBiayaLainnya, setOpenBiayaLainnya] = useState(false)
  const [listVendor, setListVendor] = useState<any[]>([])
  const [listAkun, setListAkun] = useState<any[]>([])
  const [listAkunBiaya, setListAkunBiaya] = useState<any[]>([])
  const [mode, setMode] = useState<string>('')
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const [listBiayaLainnya, setListBiayaLainnya] = useState<any[]>([])
  const [listInvoiceTerbayar, setListInvoiceTerbayar] = useState<any[]>([])

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useForm<FormInputs>({
    defaultValues: {
      tgl: moment().format('YYYY-MM-DD')
    }
  })

  // ================= GET CUSTOMER =================
  const getVendor = () => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-vendor', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        setListVendor(res.data.data)
      }
    })
  }

  // ================= GET AKUN =================
  const getAkun = () => {
    axios.get(apiUrl.apiUrl + '/acc/arr/get-akun', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        setListAkun(res.data.data)

        getNomorPenerimaan(id)
        getDetail(id)
      }
    })
  }

  const getAkunBiaya = () => {

    let url = apiUrl.apiUrl + '/acc/account/list-akun-biaya'

    axios
      .get(url, {
        params: {},
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const data = response.data.data

          setListAkunBiaya(data)
        } else {
          showToast(response.data.message, 'error');
        }
      })
  }

  // ================= GET NOMOR PENERIMAAN =================
  const getNomorPenerimaan = (id: any) => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-list-nomor-penerimaan', {
      params: { id },
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data
        setValue('nomor_penerimaan', data.id)
        setValue('sisa_saldo', data.sisa_saldo)
      }
    })
  }

  // ================= GET DETAIL =================
  const getDetail = (id: any) => {
    axios.get(apiUrl.apiUrl + '/acc/app/detail/' + id, {
      params: {},
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data[0]

        console.log(data)

        setValue('vendor_id', data.pbsupplier_id)
        setValue('vendor_name', data.nama_vendor)
        setValue('tgl', moment(data.tgl).format('YYYY-MM-DD'))
        setValue('keterangan', data.keterangan)
        setValue('is_langsung', data.is_langsung)
        setMode(data.is_langsung)
        setValue('nomor_penerimaan', data.accapp_dp_id)
        setValue('accakun_id', data.accakun_id)
        setValue('sisa_saldo', data.sisa_saldo)
        setValue('total', data.total)
        setValue('total_valas', data.total_valas)
        setValue('total_cair', data.total_cair)

        getInvoiceTerbayar()
      }
    })
  }

  // ================= GET BIAYA LAINNYA =================
  const getBiayaLainnya = () => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-biaya-lainnya', {
      params: { id },
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data
        setListBiayaLainnya(data)
      }
    })
  }

  // ================= GET INVOICE TERBAYAR =================
  const getInvoiceTerbayar = () => {
    axios.get(apiUrl.apiUrl + '/acc/app/get-invoice-terbayar', {
      params: { id },
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
      if (res.data.success) {
        const data = res.data.data
        console.log(data)
        setListInvoiceTerbayar(data)

        getBiayaLainnya()
      }
    })
  }

  // ================= SUBMIT =================
  const onSubmit = (data: any) => {
    Swal.fire({
      title: 'Konfirmasi',
      text: 'Simpan data ini?',
      icon: 'question',
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.post(apiUrl.apiUrl + '/acc/app/update', data, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
          if (res.data.success) {
            Swal.fire('Success', res.data.message, 'success')
            navigate('/accapp')
          }
        })
      }
    })
  }

  useEffect(() => {
    getVendor()
    getAkun()
    getAkunBiaya()
  }, [])

  const handleDetail = (data: any, mode: any) => {
    const payload = {}

    let url = ''
    if (mode == 'add') {
      url = apiUrl.apiUrl + '/acc/app/tambah-detail/' + data.id
    } else {
      url = apiUrl.apiUrl + '/acc/app/hapus-detail/' + data.id
    }

    axios
      .post(url, payload, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(response => {
        if (response.data.success) {
          const pesan = response.data.data[0].pesan

          showToast(pesan, 'success');
          getNomorPenerimaan(id)
          getDetail(id)
        } else {
          showToast(response.data.message, 'error');
        }
      })
      .catch(error => {
        showToast(error.message, 'error');
      })
  }

  const actionData = [
    {
      key: "pembayaran",
      flex: 1,
      sortable: false,
      minWidth: 150,
      field: "pembayaran",
      align: "center",
      headerAlign: "center",
      headerName: "Pembayaran",
      renderCell: ({ row }: { row: any }) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="Bayar" placement="top">
            {row.total == 0 ? (
              <Button
                variant="contained"
                size="small"
                startIcon={<Icon icon="mdi:plus-circle" />}
                onClick={() => {
                  handleDetail(row, 'add')
                }}
              >
                TAMBAH
              </Button>
            ) : (
              <Button
                variant="contained"
                size="small"
                startIcon={<Icon icon="mdi:trash" />}
                onClick={() => {
                  handleDetail(row, 'delete')
                }}
              >
                HAPUS
              </Button>
            )}

          </Tooltip>
        </Box>
      ),
    },
  ];

  const actionDataBiaya = [
    {
      key: "aksi",
      flex: 1,
      sortable: false,
      minWidth: 80,
      field: "aksi",
      align: "center",
      headerAlign: "center",
      headerName: "Aksi",
      renderCell: ({ row }: { row: any }) => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Tooltip title="Hapus" placement="top">
            <IconButton onClick={() => {
              Swal.fire({
                title: 'Konfirmasi',
                text: 'Hapus biaya lainnya?',
                icon: 'question',
                showCancelButton: true
              }).then(result => {
                if (result.isConfirmed) {
                  let url = apiUrl.apiUrl + '/acc/app/delete-biaya-lainnya/' + row.id
                  axios.post(url, {}, {
                    headers: { Authorization: `Bearer ${token}` }
                  }).then(res => {
                    showToast(res.data.message, 'success')
                    getNomorPenerimaan(id)
                    getDetail(id)
                  })
                }
              })
            }}>
              <Icon icon={"mdi:trash-can-outline"} color={"red"} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  // ================= UI =================
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography variant='h5' sx={{ textAlign: 'center' }}>
              Detail AP Payment
            </Typography>
            <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
              No. Dokumen : <b>{id}</b>
            </Typography>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>

                {/* CUSTOMER */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <Controller
                      name='vendor_name'
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          label='Vendor'
                          // onClick={() => setOpenCustomer(true)}
                          InputProps={{ readOnly: true }}
                          InputLabelProps={{ shrink: true }}
                          error={Boolean(errors.vendor_name)}
                        />
                      )}
                    />
                    {errors.vendor_name && (
                      <FormHelperText error>Vendor wajib diisi</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* TANGGAL */}
                <Grid item xs={12} sm={6}>
                  <Controller
                    name='tgl'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type='date'
                        label='Tanggal'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name='nomor_penerimaan'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label='Nomor Penerimaan'
                        fullWidth
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                {/* AKUN TERIMA */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Akun Terima</InputLabel>
                    <Controller
                      name='accakun_id'
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Select {...field} label='Akun Terima' value={field.value ?? ''}>
                          {listAkun.map((item, i) => (
                            <MenuItem key={i} value={item.id}>
                              {item.kode} - {item.nama}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name='sisa_saldo'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label='Sisa Saldo'
                        fullWidth
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controller
                    name='total'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label='Total'
                        fullWidth
                        InputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                {/* KETERANGAN */}
                <Grid item xs={12}>
                  <Controller
                    name='keterangan'
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label='Keterangan'
                        multiline
                        rows={3}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                  <Button variant='contained' type='submit'>
                    UPDATE
                  </Button>
                </Grid>

              </Grid>
            </form>
            <Divider sx={{ my: 3 }} />
            <Typography variant='h6'>Detail</Typography>
            <MsiDatagridAutoPlain key={1} array={listInvoiceTerbayar} actions={actionData} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 1
              }}
            >
              <Typography fontWeight="bold" fontSize={18}>
                Total : &nbsp;
              </Typography>
              <Typography fontWeight="bold" fontSize={18}>
                {listInvoiceTerbayar.reduce((sum, item) => sum + (item.total || 0), 0).toLocaleString('id-ID')}
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 3
              }}
            >
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                <Typography variant='h6'>Biaya Lainnya</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                {/* <Fab
                  color='primary'
                  size='medium'
                  onClick={() => {
                    setOpenBiayaLainnya(true)
                  }}
                >
                  <Icon icon='mdi:plus' fontSize={35} color='white' />
                </Fab> */}
                <Button
                  variant="contained"
                  size="small"
                  sx={{ mr: 2 }}
                  startIcon={<Icon icon="mdi:plus-circle" />}
                  onClick={() => {
                    setMode('Tambah')
                    setOpenBiayaLainnya(true)
                  }}
                >
                  TAMBAH BIAYA
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<Icon icon="mdi:trash" />}
                  onClick={() => {
                    setMode('Kurangi')
                    setOpenBiayaLainnya(true)
                  }}
                >
                  KURANGI BIAYA
                </Button>
              </Box>
            </Box>
            <MsiDatagridAutoPlain key={2} array={listBiayaLainnya} actions={actionDataBiaya} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 1
              }}
            >
              <Typography fontWeight="bold" fontSize={18}>
                Total : &nbsp;
              </Typography>
              <Typography fontWeight="bold" fontSize={18}>
                {listBiayaLainnya.reduce((sum, item) => sum + ((item.total) || 0), 0).toLocaleString('id-ID')}
              </Typography>
            </Box>

            <Box
              sx={{
                mt: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  mb: 1
                }}
              >
                <Typography fontWeight="bold" fontSize={25}>
                  Grand Total : &nbsp;
                </Typography>

                <Typography fontWeight="bold" fontSize={25}>
                  Rp. {getValues('total') ? getValues('total') : 0}
                </Typography>
              </Box>

              {/* Terbilang */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  mb: 1
                }}
              >
                <Typography fontWeight="bold" fontSize={25}>
                  Terbilang : &nbsp;
                </Typography>

                <Typography
                  fontWeight="bold"
                  fontSize={25}
                >
                  {terbilang(getValues('total') ? getValues('total') : 0)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {/* POPUP VENDOR */}
      <Dialog open={openVendor} maxWidth='lg' fullWidth>
        <DialogTitle>Pilih Vendor</DialogTitle>
        <DialogContent>
          <MsiDatagrid
            array={listVendor}
            rowClick={(e: any) => {
              const item = e.data
              setValue('vendor_id', item.id)
              setValue('vendor_name', item.nama)
              getNomorPenerimaan(item.id)
              setOpenVendor(false)
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenVendor(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} maxWidth='sm' fullWidth>
        <DialogTitle>Pembayaran</DialogTitle>
        <DialogContent>

          <form onSubmit={handleSubmit((data) => {
            setOpenDialog(false)

            const payload = {
              accinv_id: data.accinv_id,
              sisa: data.sisa,
              keterangan: data.keterangan_invoice,
              total: data.total_invoice.replace(/\./g, ''),
            }

            const url = apiUrl.apiUrl + '/acc/app/add-invoice-terbayar/' + id

            axios.post(url, payload, {
              headers: { Authorization: `Bearer ${token}` }
            }).then(res => {
              showToast(res.data.pesan, 'success')
              getNomorPenerimaan(id)
              getDetail(id)
            })

          })}>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Controller
                  name="total_invoice"
                  control={control}
                  rules={{ required: 'Total wajib diisi' }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Total"
                      fullWidth
                      inputRef={inputRef}
                      inputProps={{ inputMode: 'numeric' }}
                      onChange={(e) =>
                        field.onChange(formatNumber(e.target.value))
                      }
                      error={!!errors.total_invoice}
                      helperText={errors.total_invoice?.message as string}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button variant='contained' type='submit'>
                  SIMPAN
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <DialogBiayaLainnya
        id={id}
        tabel='accapp'
        open={openBiayaLainnya}
        onClose={() => setOpenBiayaLainnya(false)}
        onReload={() => {
          getNomorPenerimaan(id)
          getDetail(id)
        }}
      />

      <Dialog open={openBiayaLainnya} onClose={() => setOpenBiayaLainnya(false)} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit((data) => {
          setOpenBiayaLainnya(false)

          let payload = {}
          let url = ''

          if (mode == 'Tambah') {
            url = apiUrl.apiUrl + '/acc/app/tambah-biaya'
            payload = {
              accarr_id: id,
              akun: data?.akun?.id,
              keterangan: data?.keterangan_biaya,
              total: data?.total_biaya.replace(/\./g, ''),
            }
          } else {
            url = apiUrl.apiUrl + '/acc/app/hapus-biaya'
            payload = {
              accarr_id: id,
              akun: data?.akun?.id,
              keterangan: data?.keterangan_biaya,
              total: '-' + data?.total_biaya.replace(/\./g, ''),
            }
          }

          // const url = apiUrl.apiUrl + '/acc/arr/add-invoice-terbayar/' + id

          axios.post(url, payload, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(res => {
            const pesan = res.data.data[0].pesan
            showToast(pesan, 'success')
            getNomorPenerimaan(id)
            getDetail(id)
          })

        })}>
          <DialogTitle>
            {mode} Biaya Lainnya
          </DialogTitle>

          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Controller
                  name="akun"
                  control={control}
                  rules={{ required: 'Akun wajib dipilih' }}
                  render={({ field }) => (
                    <Autocomplete
                      {...field}
                      value={field.value || null}
                      options={listAkunBiaya}
                      isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                      getOptionLabel={(o) => o?.nama + " | Saldo : " + o?.saldo}
                      onChange={(_, val) => {
                        field.onChange(val)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Akun"
                          error={!!errors.akun}
                          helperText={errors.akun?.message as string}
                        />
                      )}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="total_biaya"
                  control={control}
                  rules={{ required: 'Total wajib diisi' }}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Total"
                      fullWidth
                      inputProps={{ inputMode: 'numeric' }}
                      onChange={(e) =>
                        field.onChange(formatNumber(e.target.value))
                      }
                      error={!!errors.total_biaya}
                      helperText={errors.total_biaya?.message as string}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="keterangan_biaya"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Keterangan"
                      multiline
                      rows={2}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button fullWidth variant="contained" type="submit">
              SIMPAN
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <FloatingJurnalButton
        id={Number(id)}
        tabel="accapp"
      />

    </Grid>
  )
}

export default AccAppDetail
